import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'When will I feel results?',
    a: 'Most women notice a difference in comfort and puffiness within the first week.'
  }, {
    q: 'How do I take it?',
    a: 'Simply add drops to water each morning — takes under 60 seconds.'
  }, {
    q: 'Is this safe?',
    a: 'LymphoriaX™ is made with gentle botanical support designed for daily use.'
  }, {
    q: 'Do you ship worldwide?',
    a: 'Yes — we offer free worldwide shipping to the US, Canada, Australia, New Zealand, and beyond.'
  }, {
    q: "What if it doesn't work for me?",
    a: "You're protected by our 90-day money-back guarantee."
  }];
  return <section className="py-24 bg-[#F9FAFB]" data-id="element-18">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B5E20]" data-id="element-21">FAQ</h2>
        </div>

        <div className="space-y-4" data-id="element-22">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-23" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-24">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-25">
        <span className="font-bold text-[#1B5E20]" data-id="element-26">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-27" />
      </button>
      <AnimatePresence data-id="element-28">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} data-id="element-29">
            <div className="px-6 pb-6 text-[#374151]" data-id="element-30">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}